import React, { useState, useEffect, useRef } from "react"; // أضف useRef هنا
import { useParams } from "react-router-dom";
import { db } from "./firebase";
import { ref, get } from "firebase/database";
import { useReactToPrint } from "react-to-print";

// أنقل الـ styles إلى الأعلى قبل استخدامها
const styles = {
  toolbar: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: '12px 20px',
    backgroundColor: 'white',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    zIndex: 1000
  },
  backButton: {
    padding: '8px 16px',
    backgroundColor: '#6b7280',
    color: 'white',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 500
  },
  printBtn: {
    padding: '8px 16px',
    backgroundColor: '#2563eb',
    color: 'white',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600
  },
  title: {
    margin: 0,
    fontSize: 18,
    color: '#1f2937',
    flex: 1
  },
  printContent: {
    marginTop: 50,
    padding: 30,
    backgroundColor: 'white',
    maxWidth: 900,
    marginLeft: 'auto',
    marginRight: 'auto',
    fontFamily: "'Inter', sans-serif",
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    borderRadius: 8
  },
  header: {
    textAlign: 'center',
    marginBottom: 25,
    borderBottom: '2px solid #2563eb',
    paddingBottom: 15
  },
  title_main: {
    margin: '0 0 10px 0',
    color: '#2563eb',
    fontSize: 26,
    fontWeight: 'bold',
    letterSpacing: 1
  },
  orderInfo: {
    marginTop: 5
  },
  orderNumber: {
    margin: '5px 0',
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1f2937'
  },
  orderDate: {
    margin: '5px 0',
    fontSize: 14,
    color: '#6b7280'
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 1fr',
    gap: 15,
    marginBottom: 25,
    backgroundColor: '#f9fafb',
    padding: 15,
    borderRadius: 8
  },
  infoBox: {
    padding: '0 10px'
  },
  infoTitle: {
    margin: '0 0 8px 0',
    fontSize: 13,
    fontWeight: '600',
    color: '#2563eb',
    textTransform: 'uppercase'
  },
  infoText: {
    margin: '4px 0',
    fontSize: 13,
    color: '#1f2937'
  },
  statusBadge: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: 20,
    color: 'white',
    fontSize: 12,
    fontWeight: '600'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: 25,
    fontSize: 13
  },
  th: {
    padding: '10px',
    textAlign: 'left',
    backgroundColor: '#f3f4f6',
    color: '#1f2937',
    fontWeight: '600',
    borderBottom: '2px solid #2563eb'
  },
  td: {
    padding: '8px 10px',
    borderBottom: '1px solid #e5e7eb'
  },
  tdCenter: {
    padding: '8px 10px',
    textAlign: 'center',
    borderBottom: '1px solid #e5e7eb'
  },
  tdRight: {
    padding: '8px 10px',
    textAlign: 'right',
    borderBottom: '1px solid #e5e7eb'
  },
  summaryContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 25,
    padding: 20,
    backgroundColor: '#f9fafb',
    borderRadius: 8
  },
  summaryLeft: {
    flex: 1,
    paddingRight: 20,
    borderRight: '1px dashed #d1d5db'
  },
  summaryRight: {
    flex: 1,
    paddingLeft: 20
  },
  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '6px 0',
    fontSize: 14
  },
  summaryLabel: {
    color: '#4b5563'
  },
  summaryValue: {
    color: '#1f2937',
    fontWeight: '600'
  },
  totalRow: {
    marginTop: 8,
    paddingTop: 8,
    borderTop: '2px solid #2563eb'
  },
  totalLabel: {
    color: '#1f2937',
    fontWeight: 'bold',
    fontSize: 15
  },
  totalValue: {
    color: '#2563eb',
    fontWeight: 'bold',
    fontSize: 16
  },
  paidAmount: {
    color: '#10b981',
    fontWeight: 'bold'
  },
  remainingAmount: {
    color: '#ef4444',
    fontWeight: 'bold'
  },
  debtRow: {
    marginTop: 8,
    paddingTop: 8,
    borderTop: '1px solid #e5e7eb'
  },
  debtAmount: {
    color: '#ef4444',
    fontWeight: 'bold',
    fontSize: 15
  },
  footer: {
    marginTop: 20,
    paddingTop: 15,
    textAlign: 'center',
    borderTop: '1px solid #e5e7eb',
    fontSize: 12,
    color: '#6b7280'
  },
  footerText: {
    margin: '3px 0'
  },
  komondiFooter: {
    marginTop: 8,
    fontSize: 11,
    color: '#2563eb',
    fontWeight: '500'
  },
  loading: {
    textAlign: 'center',
    padding: 40,
    fontSize: 16,
    color: '#6b7280'
  },
  error: {
    textAlign: 'center',
    padding: 40,
    color: '#ef4444',
    fontSize: 16
  }
};

export default function OrderPrintPage() {
  const { orderId, distributorId } = useParams();
  const componentRef = useRef(null); // استخدم useRef مباشرة

  const [order, setOrder] = useState(null);
  const [products, setProducts] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [finalPrice, setFinalPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [clientInfo, setClientInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [detteTotale, setDetteTotale] = useState(0);
  const [vendeurInfo, setVendeurInfo] = useState(null);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [distributor, setDistributor] = useState({
    name: "",
    phone: ""
  });

  // باقي الكود كما هو...
  // (كل الـ useEffects والدوال)
  
  // حساب الكمية الإجمالية للمنتجات
  useEffect(() => {
    if (products.length > 0) {
      const total = products.reduce((acc, product) => acc + (product.quantity || 0), 0);
      setTotalQuantity(total);
    }
  }, [products]);

  // جلب بيانات الموزع
  useEffect(() => {
    if (!distributorId) return;
    const userRef = ref(db, `users/${distributorId}`);
    get(userRef).then(snapshot => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setDistributor({
          name: data.tradeName || "",
          phone: data.phone || ""
        });
      }
    });
  }, [distributorId]);

  // حساب الديون
  const loadClientDebt = () => {
    if (!order || !distributorId) return;

    const clientId = order.clientId;
    if (!clientId) return;

    const isVendeurClient = order.nameClientAdd && order.nameClientAdd.trim() !== "";
    
    if (isVendeurClient) {
      const debtRef = ref(db, `distributors/${distributorId}/clientsAdd/${clientId}/totalDebt`);
      get(debtRef).then(snapshot => {
        if (snapshot.exists()) {
          const dette = parseFloat(snapshot.val()) || 0;
          setDetteTotale(dette);
        } else {
          setDetteTotale(0);
        }
      }).catch(error => {
        console.error("Error loading client debt:", error);
      });
    } else {
      const debtRef = ref(db, `clients/${clientId}/debtsByDistributor/${distributorId}`);
      get(debtRef).then(snapshot => {
        if (snapshot.exists()) {
          const dette = parseFloat(snapshot.val()) || 0;
          setDetteTotale(dette);
        } else {
          setDetteTotale(0);
        }
      }).catch(error => {
        console.error("Error loading client debt:", error);
      });
    }
  };

  useEffect(() => {
    loadClientDebt();
  }, [order, distributorId]);

  // جلب بيانات الطلب
  useEffect(() => {
    if (!orderId || !distributorId) return;
    
    const orderRef = ref(db, `distributors/${distributorId}/orders/${orderId}`);
    get(orderRef).then(snapshot => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setOrder(data);
        
        const productsArray = [];
        if (data.products) {
          Object.entries(data.products).forEach(([key, product]) => {
            productsArray.push({
              ...product,
              productKey: key
            });
          });
        }
        
        setProducts(productsArray);
        setDiscount(data.discountPercent || 0);
        setTotalPrice(data.totalPrice || 0);
        setFinalPrice(data.finalPrice || data.totalPrice || 0);
        
        if (data.nameClientAdd && data.nameClientAdd.trim()) {
          setClientInfo({
            name: data.nameClientAdd,
            phone: data.telClientAdd || "-",
            address: data.adresseClientAdd || "-",
            type: "vendeur"
          });
          if (data.vendeurId) {
            loadVendeurInfo(distributorId, data.vendeurId);
          }
        } else if (data.tradeName && data.tradeName.trim()) {
          setClientInfo({
            name: data.tradeName,
            phone: data.phone || "-",
            address: data.adresse || "-",
            type: "client"
          });
        } else {
          setClientInfo({
            name: "-",
            phone: "-",
            address: "-",
            type: "unknown"
          });
        }
      }
      setLoading(false);
    });
  }, [orderId, distributorId]);

  // جلب معلومات البائع
  const loadVendeurInfo = (distributorId, vendeurId) => {
    const vendeurRef = ref(db, `distributors/${distributorId}/vendeurs/${vendeurId}`);
    get(vendeurRef).then(snapshot => {
      if (snapshot.exists()) {
        const vendeur = snapshot.val();
        setVendeurInfo({
          name: vendeur.name || "",
          lastName: vendeur.lastName || ""
        });
      }
    });
  };

  // طباعة
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `Bon_Livraison_${order?.orderNumber || ""}`,
    pageStyle: `
      @media print {
        .no-print { display: none !important; }
        body { 
          font-family: 'Inter', sans-serif;
          margin: 0;
          padding: 0px;
        }
          .print-content {
        margin-top: 0 !important;
        box-shadow: none !important;
      }
      }
    `,
  });

  if (loading) return <div style={styles.loading}>Chargement...</div>;
  if (!order) return <div style={styles.error}>Bon introuvable.</div>;

  return (
    <div>
      {/* شريط الأدوات - يظهر فقط على الشاشة */}
      <div style={styles.toolbar} className="no-print">
        <button onClick={() => window.close()} style={styles.backButton}>
          ← Retour
        </button>
        <button onClick={handlePrint} style={styles.printBtn}>
          🖨️ Imprimer
        </button>
        <h2 style={styles.title}>Aperçu bon de livraison</h2>
      </div>

      {/* محتوى الطباعة */}
      <div ref={componentRef} style={styles.printContent}>
        {/* الهيدر */}
        <div style={styles.header}>
          <h1 style={styles.title_main}>BON DE LIVRAISON</h1>
          <div style={styles.orderInfo}>
            <p style={styles.orderNumber}>N° Commande: #{order?.orderNumber || "N/A"}</p>
            <p style={styles.orderDate}>Date: {order?.createdAt ? new Date(order.createdAt).toLocaleString('fr-FR') : "N/A"}</p>
          </div>
        </div>

        {/* معلومات الموزع والعميل في سطر واحد */}
        <div style={styles.infoGrid}>
          {/* الموزع */}
          <div style={styles.infoBox}>
            <h4 style={styles.infoTitle}>DISTRIBUTEUR</h4>
            <p style={styles.infoText}>{distributor.name || "Nom du distributeur"}</p>
            <p style={styles.infoText}>📞 {distributor.phone || "Téléphone"}</p>
          </div>

          {/* العميل */}
          <div style={styles.infoBox}>
            <h4 style={styles.infoTitle}>CLIENT</h4>
            {clientInfo.type === "vendeur" ? (
              <>
                <p style={styles.infoText}>{clientInfo.name}</p>
                <p style={styles.infoText}>📞 {clientInfo.phone}</p>
                <p style={styles.infoText}>📍 {clientInfo.address}</p>
                {vendeurInfo && (
                  <p style={styles.infoText}>Vendeur: {vendeurInfo.name} {vendeurInfo.lastName}</p>
                )}
              </>
            ) : (
              <>
                <p style={styles.infoText}>{clientInfo.name}</p>
                <p style={styles.infoText}>📞 {clientInfo.phone}</p>
                <p style={styles.infoText}>📍 {clientInfo.address}</p>
              </>
            )}
          </div>

          {/* Statut */}
          <div style={styles.infoBox}>
            <h4 style={styles.infoTitle}>STATUT</h4>
            <span style={{
              ...styles.statusBadge,
              backgroundColor: order?.status?.toLowerCase() === "terminé" ? "#10b981" :
                             order?.status?.toLowerCase() === "annulé" ? "#ef4444" : "#f59e0b"
            }}>
              {order?.status || "En cours"}
            </span>
          </div>
        </div>

        {/* جدول المنتجات */}
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>N°</th>
              <th style={styles.th}>Produit</th>
              <th style={styles.th}>Qté</th>
              <th style={styles.th}>Prix unit.</th>
              <th style={styles.th}>Total</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p, idx) => (
              <tr key={p.productKey || idx}>
                <td style={styles.td}>{idx + 1}</td>
                <td style={styles.td}>{p.name}</td>
                <td style={styles.tdCenter}>{p.quantity}</td>
                <td style={styles.tdRight}>{p.price?.toFixed(2)} DA</td>
                <td style={styles.tdRight}>{(p.price * p.quantity)?.toFixed(2)} DA</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ملخص الفاتورة - الجهة اليسرى واليمنى */}
        <div style={styles.summaryContainer}>
          {/* الجهة اليسرى */}
          <div style={styles.summaryLeft}>
            <div style={styles.summaryRow}>
              <span style={styles.summaryLabel}>Total quantité:</span>
              <span style={styles.summaryValue}>{totalQuantity}</span>
            </div>
            <div style={styles.summaryRow}>
              <span style={styles.summaryLabel}>Remise:</span>
              <span style={styles.summaryValue}>{discount}%</span>
            </div>
            <div style={styles.summaryRow}>
              <span style={styles.summaryLabel}>Montant remise:</span>
              <span style={styles.summaryValue}>{(totalPrice * discount / 100).toFixed(2)} DA</span>
            </div>
            <div style={{...styles.summaryRow, ...styles.totalRow}}>
              <span style={styles.totalLabel}>Total après remise:</span>
              <span style={styles.totalValue}>{finalPrice.toFixed(2)} DA</span>
            </div>
          </div>

          {/* الجهة اليمنى */}
          <div style={styles.summaryRight}>
            <div style={styles.summaryRow}>
              <span style={styles.summaryLabel}>Total prix:</span>
              <span style={styles.summaryValue}>{totalPrice.toFixed(2)} DA</span>
            </div>
            
            {order.status === "Terminé" && (
              <>
                <div style={styles.summaryRow}>
                  <span style={styles.summaryLabel}>Montant payé:</span>
                  <span style={styles.paidAmount}>{order.paidAmount?.toFixed(2) || 0} DA</span>
                </div>
                <div style={styles.summaryRow}>
                  <span style={styles.summaryLabel}>Reste:</span>
                  <span style={order.resteAmount > 0 ? styles.remainingAmount : styles.paidAmount}>
                    {order.resteAmount?.toFixed(2) || 0} DA
                  </span>
                </div>
              </>
            )}

            <div style={{...styles.summaryRow, ...styles.debtRow}}>
              <span style={styles.summaryLabel}>Solde impayé total:</span>
              <span style={detteTotale > 0 ? styles.debtAmount : styles.paidAmount}>
                {detteTotale.toFixed(2)} DA
              </span>
            </div>
          </div>
        </div>

        {/* تذييل الصفحة */}
        <div style={styles.footer}>
          <p style={styles.footerText}>Imprimé le: {new Date().toLocaleString('fr-FR')}</p>
          <p style={styles.footerText}>Par: {JSON.parse(localStorage.getItem("user") || "{}").name || "Utilisateur"}</p>
          <p style={styles.komondiFooter}>Komondi Application</p>
        </div>
      </div>
    </div>
  );
}